import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useWardrobeCard = (wardrobe, person, enabled) => {
  return useQuery({
    queryKey: ["wardrobeCard", wardrobe, person],
    enabled: enabled,
    queryFn: async () =>
      callApi({
        path: "wardrobecard",
        command: "get",
        data: JSON.stringify({
          data: {
            filter: { wardrobeId: wardrobe, staffId: person },
          },
        }),
      }),
  });
};
